import React from 'react';

const GlobalPayContext = React.createContext();

export default GlobalPayContext;
